import {
  pembiayaanDanPenanggungJawab,
  POLI_TUJUAN_IGD,
  TUJUAN_KUNJUNGAN_FISIOTERAPI,
  TUJUAN_KUNJUNGAN_NORMAL,
  TUJUAN_KUNJUNGAN_RUJUK_INTERNAL,
} from "./constants"
import { defaultDateDisplay, isNull, today, upper } from "App/utils/helpers"
import { getDetailSepByNoSep, getSearchSEP } from "../../../utils"
import { getNamaRumahSakit, getToken } from "App/utils/cookies"
import fileDownload from "js-file-download"
import { instance2 } from "App/constants"
import { itSelfEmpty, KODE_PRINTER_SETTING, removeZeroInFront, URL_SETTING } from "utils/all"
import { getSep } from "pages/WsBridging/Sep/Sep/ui/helpers"
import { urlFilterInternal } from "../helpers"

export const getPembiayaanName = (str) => {
  return pembiayaanDanPenanggungJawab.filter(
    (item) => parseInt(item.value) === parseInt(str),
  )
}

export const getTujuanKunjungan = (type, tujuan_kunjungan) => {
  if (type !== "RJ") {
    return TUJUAN_KUNJUNGAN_NORMAL
  } else {
    if (
      tujuan_kunjungan === TUJUAN_KUNJUNGAN_RUJUK_INTERNAL ||
      tujuan_kunjungan === TUJUAN_KUNJUNGAN_FISIOTERAPI
    ) {
      return TUJUAN_KUNJUNGAN_NORMAL
    } else {
      return tujuan_kunjungan.toString()
    }
  }
}

export const jenisPelayananName = (str) => {
  if (parseInt(str) === 1) {
    return "Rawat Inap"
  } else if (parseInt(str) === 2) {
    return "Rawat Jalan"
  } else {
    return "Tidak Ditemukan"
  }
}

export const handleClickPrintSep = (formData, type) => {
  /**
   * jika igd maka poli tujuan default IGD - INSTALASI GAWAT DARURAT
   * jika rawat inap maka poli tujuan -
   *
   * jika rawat inap maka kelas rawat dan hak kelas default kelas 3
   * jika igd dan rj kelas rawat default kelas 3
   */

  const jenis_rawat =
    type === "RJ" ? "Rawat Jalan" : type === "RI" ? "Rawat Inap" : "IGD"

  const poli_tujuan =
    type === "IGD"
      ? POLI_TUJUAN_IGD
      : type === "RI"
      ? "-"
      : formData.poli_tujuan_print

  return window.open(
    `http://localhost/${
      process.env.REACT_APP_PRINT_NAME
    }/public/api/print-sep?no_sep=${formData.no_sep}&nama_rm=${
      formData.nama
    }&no_rm=${formData.patientID}&no_kartu=${formData.no_kartu}&tgl_lahir=${
      formData.tglLahir
    }&jenis_kelamin=${
      formData.jenisKelamin == 'L' ? 'Laki-laki': formData.jenisKelamin == 'P' ? 'Perempuan' : ''
    }&poli_tujuan=${poli_tujuan}&asal_faskes=${
      formData.ppk_rujukan_name
    }&pekerjaan=${formData.pekerjaan}&jenis_rawat=${jenis_rawat}&kelas_rawat=${
      formData.hak_kelas
    }&hak_kelas=${formData.hak_kelas}&diagnosa_awal=${
      formData.diagnosa_awal_name
    }&catatan=${formData.catatan}&tgl_sep=${defaultDateDisplay(
      formData.tgl_sep,
      false,
    )}&prolanisPRB=${itSelfEmpty(formData?.prolanisPRB, "", `(${upper(formData.prolanisPRB)})`) }&registrasi_id=${
      formData.id_registration
    }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
      KODE_PRINTER_SETTING.printer_sep_loket
    }&no_tlp=${formData.no_tlp}`,
    "MsgWindow",
  )
}

export const defaultStateSep = ({
  detailSep = "",
  registrationID = "",
  type,
  pekerjaan,
  dokterNama,
  dokterKodeBridge,
  poliSEP,
  noBPJS,
  noRujukan,
  noKontrol,
  patientID,
}) => {
  const responseDetailSEP = isNull(detailSep) ? "" : detailSep.response.response

  const requestDetailSEP = isNull(detailSep) ? "" : detailSep.request

  const diagnosaDetail = isNull(detailSep)
    ? ""
    : responseDetailSEP.sep.diagnosa.split(" - ")

  return {
    patientID,
    nama: isNull(detailSep) ? "" : responseDetailSEP.sep.peserta.nama,
    id_registration: registrationID,
    nik: isNull(detailSep) ? "" : "Tidak ada response NIK",
    asal_rujukan: type === "RJ" || type === "MANUAL" ? "1" : "",
    pekerjaan: pekerjaan,

    dpjp_layanan_kode: isNull(dokterKodeBridge) ? null : dokterKodeBridge,
    dpjp_layanan_name: isNull(dokterNama) ? "" : dokterNama,

    kode_dpjp: isNull(dokterKodeBridge) ? "" : dokterKodeBridge,
    kode_dpjp_dokter: isNull(dokterNama) ? "" : dokterNama,

    flag_procedure: "",
    kode_penunjang: "",
    cob: isNull(detailSep) ? 0 : parseInt(requestDetailSEP.cob),
    /**
     * Jika RJ
     */

    tujuan_kunjungan: TUJUAN_KUNJUNGAN_NORMAL,
    assesment_pel: "",
    penanggung_jawab: "Pribadi",
    pembiayaan: isNull(detailSep) ? "" : parseInt(requestDetailSEP.pembiayaan),

    tgl_rujukan: isNull(detailSep) ? today() : requestDetailSEP.tgl_rujukan,
    ppk_rujukan_name: "",
    ppk_rujukan_kode: "",
    ppk_rujukan_search: "",
    poli_tujuan_print: "",

    /**
     * End RJ
     */

    /**
     * Jika RI
     */
    suplesi: isNull(detailSep) ? "" : requestDetailSEP?.suplesi ?? "",
    nama_suplesi: isNull(detailSep)
      ? ""
      : isNull(requestDetailSEP?.suplesi)
      ? ""
      : requestDetailSEP?.suplesi === 0
      ? "Induk"
      : "Suplesi",
    kls_rawat_hak: isNull(detailSep) ? "2" : requestDetailSEP.kls_rawat_hak,
    kls_rawat_naik: isNull(detailSep) ? null : requestDetailSEP.kls_rawat_naik,
    kls_rawat_naik_name: isNull(detailSep)
      ? "Pilih Kelas Rawat"
      : requestDetailSEP.kls_rawat_naik_name,
    /**
     * End RI
     */

    no_kartu: isNull(detailSep) ? "" : responseDetailSEP.sep.peserta.noKartu,
    status: isNull(detailSep) ? 0 : 1,
    hak_kelas: isNull(detailSep) ? "" : responseDetailSEP.sep.peserta.hakKelas,
    tgl_pelayanan: isNull(detailSep) ? "-" : responseDetailSEP.sep.tglSep,

    catatan: isNull(detailSep) ? "" : responseDetailSEP.sep.catatan,

    no_sep: isNull(detailSep) ? "-" : responseDetailSEP.sep.noSep,
    tgl_sep: isNull(detailSep) ? "-" : responseDetailSEP.sep.tglSep,
    no_rujukan: type === "RJ" ? noRujukan : "",
    nokontrol: noKontrol,

    diagnosa_awal: isNull(detailSep) ? null : diagnosaDetail[0],
    diagnosa_awal_name: isNull(detailSep)
      ? "Pilih Diagnosa Awal"
      : diagnosaDetail[1],
    diagnosa_name: isNull(detailSep) ? "" : diagnosaDetail[0],

    nomor_sep_suplesi: isNull(detailSep)
      ? ""
      : requestDetailSEP.nomor_sep_suplesi,
    nomor_sep: "",
    keterangan: isNull(detailSep) ? "" : requestDetailSEP.keterangan,

    kode_propinsi: isNull(detailSep) ? null : requestDetailSEP.kode_propinsi,
    nama_propinsi: isNull(detailSep)
      ? "Pilih Provinsi"
      : requestDetailSEP.nama_propinsi,

    kode_kabupaten: isNull(detailSep) ? null : requestDetailSEP.kode_kabupaten,
    nama_kabupaten: isNull(detailSep)
      ? "Pilih Kabupaten"
      : requestDetailSEP.nama_kabupaten,

    kode_kecamatan: isNull(detailSep) ? null : requestDetailSEP.kode_kecamatan,
    nama_kecamatan: isNull(detailSep)
      ? "Pilih Kecamatan"
      : requestDetailSEP.nama_kecamatan,

    // poliklinik_name: type === "RJ" ? poliSEP.label : "",
    // poliklinik_id: type === "RJ" ? poliSEP.value : "",

    kode_poliklinik: type === "RJ" ? poliSEP.value : null,
    nama_poliklinik: type === "RJ" ? poliSEP.label : "Pilih Poliklinik",

    is_bayi: false,
    katarak: isNull(detailSep) ? 0 : parseInt(requestDetailSEP.katarak),
    laka_lantas: isNull(detailSep) ? 0 : parseInt(requestDetailSEP.laka_lantas),
    tgl_kejadian: isNull(detailSep) ? "" : requestDetailSEP.tgl_kejadian,

    insurance_no: noBPJS,

    prolanisPRB: null,
  }
}

export const getProfilPasien = async (patientID) => {
  const api = await instance2.get(urlFilterInternal, {
    headers: {
      idrm: removeZeroInFront(patientID),
      limit: 1,
      pages: 1,
      jenisrm: parseInt(2),
      status: 1,
    },
  });
  const response = api.data
  if (!isNull(response?.body?.length) && response.body?.length === 1) {
    return {
      state: true,
      data: response?.body,
    }
  } else {
    return {
      state: false,
      data: [],
      message: 'Pasien Tidak Ditemukan',
    }
  }
}

export const checkBackdateSEP = async (id_kunjungan) => {
  const api = await instance2.get('vclaim-bridging/list-sep-by-id-kunjungan', {
    params: {
      id_kunjungan: id_kunjungan,
      jenis_pengajuan: "1",
      status: 200,
    },
  });
  const response = api.data
  if (response?.status === 200) {
    return {
      state: true,
      data: response?.body,
    }
  } else {
    return {
      state: false,
      data: [],
      message: '',
    }
  }
}

export const handleClickCetakSep = async (formData) => {
  let isBackDate = false;
  const resDetailSEP = getDetailSepByNoSep(formData.no_sep)
  const resNomorKartu = getSearchSEP({
    type: "1",
    nomor_kartu: formData.no_kartu,
    tgl_pelayanan: today(),
  })
  const resDataSEP = getSep(formData.no_sep)
  const resProfilPasien = getProfilPasien(
    removeZeroInFront(formData.patientID.toString()),
  );
  const resCheckBackDate = checkBackdateSEP(formData.id_registration);

  await Promise.all([
    resDataSEP,
    resDetailSEP,
    resProfilPasien,
    resNomorKartu,
    resCheckBackDate,
  ]).then(async (responses) => {
    const response1 = responses[0]
    const response2 = responses[1]
    const response3 = responses[2]
    const response4 = responses[3]
    const response5 = responses[4]
    if (
      response1.state &&
      response2.state &&
      response3.state &&
      response4.state
    ) {
      const EP1 = response1.data
      const EP2 = response2.data
      const EP3 = response3.data
      const dataResNoKartu = response4.data.peserta
      const rm = dataResNoKartu.mr.noMR
      const nama = formData.nama

      if(response5.state){
        if(!isNull(response5?.data?.length) && response5?.data?.length > 0){
          isBackDate = true
        }else{
          isBackDate = false
        }
      }else{
        isBackDate = false
      }

      const payload = {
        nama_rumah_sakit: getNamaRumahSakit(),
        no_sep: formData.no_sep,
        tgl_sep: EP1.tglSep,
        no_kartu: EP1.peserta.noKartu,
        rm: rm,
        nama: nama,
        tgl_lahir: EP1.peserta.tglLahir,
        jenis_kelamin: EP1?.peserta?.kelamin == 'L' ? 'Laki-laki': EP1?.peserta?.kelamin == 'P' ? 'Perempuan' : '',
        no_tlp: EP3?.[0]?.mobile_phone_number??null,
        spesialis: EP1.poli,
        dokter: EP1.jnsPelayanan === 'Rawat Inap' ? EP1.kontrol.nmDokter : EP1.dpjp.nmDPJP,
        faskes_perujuk: EP2.provPerujuk.nmProviderPerujuk,
        diagnosa_awal: EP2.diagnosa,
        catatan: EP1.catatan,
        peserta:  EP1.peserta.jnsPeserta,
        jns_rawat: EP1.jnsPelayanan,
        jns_kunjungan: EP1.tujuanKunj.nama,
        poli_perujuk: "",
        kls_hak: EP1.peserta.hakKelas,
        // kls_rawat: isNull(formData.kls_rawat_naik_name)
        //   ? ""
        //   : formData.kls_rawat_naik_name,
        kls_rawat: EP1.jnsPelayanan !== 'Rawat Inap' ? "" : EP1.kelasRawat,
        penjamin: EP1?.penjamin??" ",
        isBackDate: isBackDate,
        prosedur: EP1?.flagProcedure?.nama??"",
        prolanisPRB: itSelfEmpty(dataResNoKartu?.informasi?.prolanisPRB, "" , `PASIEN ${upper(dataResNoKartu?.informasi?.prolanisPRB)}`),
      }

      const response = await instance2.post("/sep_regist/cetak-pdf", payload, {
        responseType: "blob",
      });
      fileDownload(response.data, `${rm}_${nama}.pdf`)
    }
  })

}
